import React, { useEffect, useState } from "react";
import TotalDue from "./TotalDue";

function MonthlyTotalDue(props) {
    const { title, calculateBy, equipments, equipmentCount } = props;
    const [saasDue, setSaasDue] = useState(0);

    useEffect(() => {
        let total = 0;
        Object.keys(equipments).map((type) =>
            Object.keys(equipments[type]).map((slug) => {
                const slugs = equipments[type][slug];
                if (slugs?.length > 0 && +slugs[0]?.sass_fee)
                    total +=
                        parseFloat(slugs[0]?.sass_fee_default) * slugs?.length;
            }),
        );
        setSaasDue(total);
    }, [equipments, equipmentCount]);

    return (
        <div>
            {Object.keys(equipments).map((type) =>
                Object.keys(equipments[type]).map((slug) => {
                    const slugs = equipments[type][slug];
                    return (
                        slugs?.length > 0 &&
                        slugs[0]?.sass_fee > 0 && (
                            <div className="cost-item">
                                <span className="text">{`Saas fee for ${slugs[0]?.equipment_name}`}</span>
                                <span className="dots"></span>
                                <span className="amount highlighted">
                                    ${" "}
                                    {(
                                        parseFloat(slugs[0]?.sass_fee_default) *
                                        slugs?.length
                                    )?.toFixed(2)}
                                </span>
                            </div>
                        )
                    );
                }),
            )}
            <TotalDue
                title={title}
                calculateBy={calculateBy}
                equipments={equipments}
                otherDue={saasDue}
            />
        </div>
    );
}

export default MonthlyTotalDue;
